import { Component, output, input } from '@angular/core';

import {
  ArmLogoComponent,
  LockIconComponent,
  BellIconComponent,
  HamburgerIconComponent,
} from '../icons';

@Component({
  selector: 'lib-navbar',
  standalone: true,
  imports: [
    ArmLogoComponent,
    LockIconComponent,
    BellIconComponent,
    HamburgerIconComponent,
  ],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css',
})
export class NavbarComponent {
  // Input for encryption state
  isDataLocked = input<boolean>(false);

  // Navigation menu button (used when the sidebar is shown as a drawer)
  showMenuButton = input<boolean>(false);
  isMenuOpen = input<boolean>(false);
  menuControlsId = input<string | null>(null);

  // Event outputs for parent communication
  lockClick = output<void>();
  bellClick = output<void>();
  menuClick = output<void>();

  handleLockClick(): void {
    this.lockClick.emit();
  }

  handleBellClick(): void {
    this.bellClick.emit();
  }

  handleMenuClick(): void {
    this.menuClick.emit();
  }
}
